import { z } from 'zod';

/**
 * User management DTOs (Cognito IDP-backed).
 */

export const inviteUserSchema = z.object({
  email: z.string().email(),
  role: z.enum(['ops_analyst', 'ops_admin']),
});

export const changeRoleSchema = z.object({
  role: z.enum(['ops_analyst', 'ops_admin']),
});

export const userSchema = z.object({
  userId: z.string(),
  email: z.string(),
  role: z.enum(['ops_analyst', 'ops_admin', 'none']),
  status: z.string(),
  createdAt: z.string(),
});

export const userListResponseSchema = z.object({
  data: z.array(userSchema),
});

export type InviteUser = z.infer<typeof inviteUserSchema>;
export type ChangeRole = z.infer<typeof changeRoleSchema>;
export type UserResponse = z.infer<typeof userSchema>;
export type UserListResponse = z.infer<typeof userListResponseSchema>;
